import { useState, useMemo } from 'react'
import './App.css'
import data from './data.json'
import DataTable from './DataTable'
import SearchBar from './SearchBar'
import Banner from './Banner'
import InfoBoxes from './InfoBoxes'
import { isApprovedStatus } from './utils'

function App() {
  const [filter, setFilter] = useState('')

  const filteredData = useMemo(() => {
    if (!filter) return data
    return data.filter(item =>
      Object.values(item).some(value =>
        String(value).toLowerCase().includes(filter.toLowerCase())
      )
    )
  }, [filter])
  
  // Calculate statistics for info boxes
  const totalProposals = data.length;
  const approvedProposals = useMemo(() => {
    return data.filter(item => isApprovedStatus(item.Status)).length;
  }, [data]);

  return (
    <div className="App" style={{ width: '100%', maxWidth: '100%', padding: 0, margin: 0 }}>
      <Banner />
      <div style={{ width: '90%', margin: '0 auto' }}>
        <h1>Projetos de Lei sobre Criptomoedas no Brasil</h1>
        
        <div className="info-boxes-wrapper">
          <InfoBoxes 
            totalProposals={totalProposals} 
            approvedProposals={approvedProposals}
            tableData={data}
          />
        </div>
        
        <div className="table-container" style={{ marginBottom: '25px' }}>
          <SearchBar filter={filter} setFilter={setFilter} />
        </div>
        
        <DataTable data={filteredData} />
        
        <div className="newsletter-box">
          <h2>Nossa newsletter vai mudar sua vida</h2>
          <p>A "Café Com Satoshi" já transformou incontáveis brasileiros em bitcoiners. Descubra porquê:</p>
          <a href="https://www.cafecomsatoshi.com.br/" target="_blank" rel="noopener noreferrer" className="cta-button">QUERO VER</a>
        </div>
      </div>
    </div>
  )
}

export default App
